const manutencao_de_visao_de_ensino = {
  path: "/manutencao-de-visao-de-ensino",
  redirect: "/manutencao-de-visao-de-ensino",
  meta: {
    breadCrumb: "Processo de Matrículas - Retrato de Matrícula Diária",
  },
  children: [
    {
      path: "/manutencao-de-visao-de-ensino",
      name: "manutencao-de-visao-de-ensino-listagem",
      component: () =>
        import("@/views/ManutencaoVisaoDeEnsino/ManutencaoVisaoDeEnsino.vue"),
    },
    {
      path: "/manutencao-de-visao-de-ensino/cadastro",
      name: "manutencao-de-visao-de-ensino-novo",
      component: () =>
        import(
          "@/views/ManutencaoVisaoDeEnsino/ManutencaoVisaoDeEnsinoCad.vue"
        ),
    },
    {
      path: "/manutencao-de-visao-de-ensino/edicao/:id",
      name: "manutencao-de-visao-de-ensino-editar",
      component: () =>
        import(
          "@/views/ManutencaoVisaoDeEnsino/ManutencaoVisaoDeEnsinoEdit.vue"
        ),
    },
  ],
};

export { manutencao_de_visao_de_ensino };
